import { compose } from 'recompose';
import History from './history';

const enhance = compose();
export default enhance(History);
